<template>
  <div class="page-bg min-vh-100 d-flex align-items-center py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-xl-7">
          <div class="glass-card rounded-4 shadow-lg p-4 p-md-5">
            <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <div class="mb-3">
                <img
                    src="https://university.dmbgroup.online/wp-content/uploads/2025/06/51186b5bf7e78bc19b2c2d035e39e95e_210004-15-1111.png"
                    alt="Familia protegida con seguro de vida"
                    class="img-fluid rounded-4 w-100"
                    style="height: 150px; object-fit: cover;"
                />
              </div>
              <h1 class="h3 mb-0 fw-semibold">Cotiza tu seguro de vida</h1>
              <div class="d-flex gap-2 small flex-wrap">
                <span class="badge rounded-pill text-bg-light" style="color: black"><i class="bi bi-shield-check me-1"></i>Aseguradora A+</span>
                <span class="badge rounded-pill text-bg-light" style="color: black"><i class="bi bi-heart-pulse me-1"></i>Sin examen médico*</span>
                <span class="badge rounded-pill text-bg-light" style="color: black"><i class="bi bi-clock me-1"></i>En 2 minutos</span>
              </div>
            </div>
            <p class="text-secondary mb-4">Completa el formulario y un asesor te contactará en breve.</p>

            <form
                v-if="!submitted"
                ref="formEl"
                class="needs-validation"
                novalidate
                @submit.prevent="handleSubmit"
            >
              <div class="row g-3">
                <div class="col-12">
                  <label for="fullName" class="form-label">Nombre completo</label>
                  <div class="input-group input-group-lg">
                    <span class="input-group-text bg-transparent border-end-0"><i class="ri-user-line align-bottom me-2 text-muted"></i></span>
                    <input id="fullName" type="text" class="form-control form-control-lg border-start-0" v-model.trim="form.fullName" autocomplete="name" required placeholder="Ej.: Jane Doe" />
                    <div class="invalid-feedback">Ingresa tu nombre completo.</div>
                  </div>
                </div>

                <div class="col-12">
                  <label for="phone" class="form-label">Teléfono</label>
                  <div class="input-group input-group-lg">
                    <span class="input-group-text bg-transparent border-end-0"><i class="ri-phone-line align-bottom me-2 text-muted"></i></span>
                    <!-- ✨ Formateo en vivo + validación personalizada -->
                    <input
                        id="phone"
                        ref="phoneEl"
                        type="tel"
                        class="form-control form-control-lg border-start-0"
                        v-model="form.phone"
                        inputmode="tel"
                        autocomplete="tel"
                        placeholder="(555) 123-4567"
                        required
                        @input="onPhoneInput"
                        @blur="onPhoneBlur"
                    />
                    <div class="invalid-feedback">Ingresa 10 dígitos (EE. UU.).</div>
                  </div>
                  <div class="form-text">
                    <template v-if="phoneDigitsLen === 10">
                      Se enviará como <strong>{{ normalizedPhone }}</strong>
                    </template>
                    <template v-else>
                      Formato EE. UU. (10 dígitos). Lo normalizaremos a E.164 automáticamente.
                    </template>
                  </div>
                </div>

                <div class="col-12">
                  <label for="email" class="form-label">Email</label>
                  <div class="input-group input-group-lg">
                    <span class="input-group-text bg-transparent border-end-0"><i class="ri-mail-line align-bottom me-2 text-muted"></i></span>
                    <input id="email" type="email" class="form-control form-control-lg border-start-0" v-model.trim="form.email" autocomplete="email" required placeholder="you@example.com" />
                    <div class="invalid-feedback">Ingresa un email válido.</div>
                  </div>
                </div>

                <div class="col-12">
                  <label for="state" class="form-label">Estado</label>
                  <div class="input-group input-group-lg">
                    <span class="input-group-text bg-transparent border-end-0"><i class="ri-earth-line align-bottom me-2 text-muted"></i></span>
                    <select id="state" class="form-select form-select-lg border-start-0" v-model="form.state" required>
                      <option value="" disabled>Selecciona tu estado</option>
                      <option v-for="s in states" :key="s.code" :value="s.code">{{ s.name }}</option>
                    </select>
                    <div class="invalid-feedback">Selecciona tu estado.</div>
                  </div>
                </div>
              </div>

              <div class="d-grid d-sm-flex gap-2 mt-4">
                <button type="submit" class="btn btn-primary btn-lg px-4" :disabled="isSubmitting">
                  <span v-if="!isSubmitting"><i class="bi bi-magic me-2"></i>Solicitar cotización</span>
                  <span v-else class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  <span v-if="isSubmitting">Enviando…</span>
                </button>
                <button type="button" class="btn btn-outline-secondary btn-lg px-4" @click="resetForm" :disabled="isSubmitting">Limpiar</button>
              </div>

              <p class="small text-secondary mt-3 mb-0">
                Al enviar aceptas ser contactad@ por teléfono, SMS o email. *La elegibilidad para omitir examen médico depende del producto.
              </p>
            </form>

            <!-- 🔹 Mensaje de agradecimiento cuando se envía -->
            <div v-else class="text-center py-5">
              <div class="mb-3">
                <i class="bi bi-check-circle-fill text-success" style="font-size: 3rem;"></i>
              </div>
              <h2 class="fw-bold">¡Gracias, {{ form.fullName || 'amig@' }}!</h2>
              <p class="lead mt-2">
                Hemos recibido tu solicitud de <strong>{{ selectedStateName }}</strong>.
                Pronto uno de nuestros asesores se pondrá en contacto contigo para ayudarte con tu seguro de vida.
              </p>
              <p class="text-muted">
                Te escribiremos a <strong>{{ form.email }}</strong> y llamaremos al <strong>{{ normalizedPhone }}</strong>.
              </p>
            </div>

            <div v-if="submitted" class="alert alert-success mt-4 mb-0" role="alert">
              ¡Gracias, {{ form.fullName || 'amig@' }}! Registramos tu solicitud de <strong>{{ selectedStateName }}</strong>. Te escribiremos a <strong>{{ form.email }}</strong> y llamaremos al <strong>{{ normalizedPhone }}</strong> pronto.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, watch } from 'vue'
import axios from "axios";
import Swal from "sweetalert2";

const formEl = ref(null)
const phoneEl = ref(null)
const submitted = ref(false)
const isSubmitting = ref(false)

// eslint-disable-next-line no-undef
const props = defineProps({
  agentId: { type: String, required: true }
})
const agentIdNum = computed(() => Number(props.agentId || 0))

watch(agentIdNum, (id) => {
  if (id && !Number.isNaN(id)) {
    updateDepartmentByID(id).catch(err => {
      console.error('updateDepartmentByID:', err)
    })
  }
}, { immediate: true }) // se ejecuta al montar y en cambios de la ruta

// Form state
const form = reactive({ fullName: '', phone: '', email: '', state: '' })

// ⚠️ Antes era [], lo usamos como objeto con defaults
const clientData = reactive({
  gender: 'N/A',
  language: 0,
  type: 0,
  leadType: 'Events',
  status: 1,
  address: 'N/A',
  city: 'N/A',
  country: 'N/A',
  departmentID: '',
  email: '',
  interview: '',
  note: '',
  postalCode: 'N/A',
  length: ''
})

const states = [
  { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' }, { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' }, { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' }, { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' }, { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' }, { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' }, { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' }, { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' }, { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' }, { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' }
]

const selectedStateName = computed(() => {
  const f = states.find(s => s.code === form.state)
  return f ? f.name : '—'
})

/* ========== Teléfono: helpers ========== */
const phoneDigitsLen = computed(() => getDigits(form.phone).length)

const normalizedPhone = computed(() => {
  const d = getDigits(form.phone)
  if (d.length === 10) return `+1${d}`
  if (d.length === 11 && d.startsWith('1')) return `+${d}`   // '+1' + 10 dígitos
  return form.phone || ''
})

function getDigits (str) {
  let out = ''
  const s = String(str || '')
  for (let i = 0; i < s.length; i++) {
    const c = s[i]
    if (c >= '0' && c <= '9') out += c
  }
  return out
}

function formatUSPhone (digits) {
  const d = digits.slice(0, 10)
  if (d.length === 0) return ''
  if (d.length <= 3) return `(${d}`
  if (d.length <= 6) return `(${d.slice(0,3)}) ${d.slice(3)}`
  return `(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`
}

function setPhoneValidity () {
  const el = phoneEl.value
  if (!el) return
  const len = phoneDigitsLen.value
  if (len === 0) { el.setCustomValidity(''); return } // required se encarga del vacío
  if (len !== 10) el.setCustomValidity('Ingresa 10 dígitos (EE. UU.).')
  else el.setCustomValidity('')
}

/* Eventos del input: formateo en vivo + validación */
function onPhoneInput (e) {
  const el = phoneEl.value || e.target
  const digits = getDigits(el.value).slice(0, 10)
  const formatted = formatUSPhone(digits)
  form.phone = formatted
  el.value = formatted
  setPhoneValidity()
}
function onPhoneBlur () { setPhoneValidity() }

/* ========== Submit / Reset ========== */
async function handleSubmit (e) {
  setPhoneValidity()
  const el = formEl.value
  if (!el.checkValidity()) {
    e.stopPropagation()
    el.classList.add('was-validated')
    return
  }

  isSubmitting.value = true
  try {
    // Split de nombre
    const parts = String(form.fullName || '').trim().split(/\s+/)
    const first = parts[0] || ''
    const last = parts.slice(1).join(' ')

    // ✅ Trae el departmentID correctamente (sin "this" y con await)
    // Si ya lo llenaste antes vía watch/update, puedes usar clientData.departmentID || ...
    const departmentID =  await updateDepartmentByID(agentIdNum.value)
    console.log(departmentID)

    // Teléfono E.164
    const digits = getDigits(form.phone)
    const phoneE164 = digits.length === 10 ? `+1${digits}` : normalizedPhone.value

    // Armar formValues
    const formValues = {
      address: clientData.address,
      city: clientData.city,
      country: clientData.country,
      department: departmentID,                     // ✅ ahora es un número/id real
      email: form.email,
      firstName: first,
      interview: clientData.interview || '',
      language: clientData.language,
      lastName: last,
      leadType: clientData.leadType,
      note: clientData.note,
      phoneNumber: phoneE164,
      postalCode: clientData.postalCode,
      state: form.state,
      status: clientData.status,
      length: clientData.length,
      gender: clientData.gender,
      agentId: agentIdNum.value
    }

    const values = { 0: { formValues, addedChilds: [], note: { note: clientData.note } } }

    const data = {
      clientsInfo: values,
      token: localStorage.getItem('jwt'),
      userID: localStorage.getItem('id'),
      userEmail: localStorage.getItem('email'),
      isProspect: 0,
      totalClients: 1,
      agentId: agentIdNum.value
    }

    // headers opcionales (Bearer)
    const token = localStorage.getItem('jwt')
    const headers = token
        ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
        : { 'Content-Type': 'application/json' }

    const response = await axios.post('/api/client/createProspectForm', data, { headers })

    if (response !== false) {
      document.getElementById('closemodal')?.click()
      document.getElementById('addform')?.reset()
      submitted.value = true
    } else {
      throw new Error('Respuesta inesperada del servidor')
    }
  } catch (error) {
    // Muestra por qué falló (si fue red, CORS, 4xx/5xx, etc.)
    const status = error?.response?.status
    const msg = status
        ? `HTTP ${status} ${error?.config?.url || ''}`
        : (error?.message || 'Network/CORS error')

    await Swal.fire({
      icon: 'error',
      title: 'No se pudo crear el cliente',
      text: msg
    })
    console.error('createProspectForm error:', error)
  } finally {
    isSubmitting.value = false
  }
}


// Devuelve SIEMPRE un string con el valor retornado por la API (por ej. departmentID)
// y, si existe clientData en el scope, lo actualiza como string.
async function updateDepartmentByID(agentIdNum) {
  if (agentIdNum == null || Number.isNaN(Number(agentIdNum))) {
    throw new Error('agentIdNum inválido');
  }

  const token = localStorage.getItem('jwt');
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  try {
    // Ajusta la URL si usas baseURL/proxy (recomendado: '/api/getDepartmentByID')
    const { data } = await axios.get('/api/getDepartmentByID', {
      params: { agentId: Number(agentIdNum) },
      headers
    });

    let valueStr = null;

    // Si la API devuelve un primitivo directamente (string/number/bool)
    if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean') {
      valueStr = String(data);
    } else if (data && typeof data === 'object') {
      // Extrae de posibles llaves y fuerza a string
      const raw =
          data.departmentID ??
          data.departmentId ??
          data?.department?.id ??
          data?.data?.departmentID ??
          data?.data?.departmentId ??
          null;

      if (raw != null) valueStr = String(raw);
    }

    if (!valueStr) {
      throw new Error('No se encontró departmentID en la respuesta');
    }

    // Actualiza estado global/local si existe
    if (typeof clientData !== 'undefined' && clientData) {
      clientData.departmentID = valueStr;
    }

    return valueStr;
  } catch (err) {
    if (typeof Swal !== 'undefined') {
      await Swal.fire({
        icon: 'error',
        title: 'Error al cargar departamento',
        text: err?.response?.data?.message || err.message || 'Error desconocido'
      });
    }
    throw err;
  }
}


function resetForm () {
  form.fullName = ''
  form.phone = ''
  form.email = ''
  form.state = ''
  submitted.value = false
  formEl.value?.classList.remove('was-validated')
  phoneEl.value?.setCustomValidity('')
}

</script>

<style scoped>
:root {
  --glass-bg: rgba(255,255,255,.82);
  --glass-brd: rgba(255,255,255,.45);
}

/* Fondo moderno con gradientes y patrón sutil */
.page-bg {
  position: relative;
  background: radial-gradient(1200px 500px at 10% -10%, #dbe7ff 0%, rgba(219,231,255,0) 60%),
  radial-gradient(1200px 600px at 110% 10%, #ffe7f1 0%, rgba(255,231,241,0) 60%),
  linear-gradient(180deg, #f7f9ff 0%, #f7f7fb 100%);
  overflow: hidden;
}
.page-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
      radial-gradient(circle at 10% 20%, rgba(79,70,229,.12), transparent 35%),
      radial-gradient(circle at 90% 30%, rgba(236,72,153,.12), transparent 40%),
      radial-gradient(circle at 30% 80%, rgba(14,165,233,.12), transparent 40%);
  pointer-events: none;
}

.glass-card {
  background: var(--glass-bg);
  border: 1px solid var(--glass-brd);
  backdrop-filter: blur(12px) saturate(120%);
}

.input-group-text { border-right: 0; }
.input-group .form-control, .input-group .form-select { border-left: 0; }

.btn-primary {
  --bs-btn-bg: #4f46e5;
  --bs-btn-border-color: #4f46e5;
  --bs-btn-hover-bg: #4338ca;
  --bs-btn-hover-border-color: #4338ca;
}
</style>
